function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryPill = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _Button = require("../Button");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var CategoryPill = exports.CategoryPill = (0, _react.memo)(function (_ref) {
  var slug = _ref.slug,
    label = _ref.label,
    containerStyle = _ref.containerStyle,
    backgroundColor = _ref.backgroundColor,
    textColor = _ref.textColor,
    onPress = _ref.onPress,
    ariaLabel = _ref.ariaLabel,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    Icon = _ref.Icon,
    href = _ref.href,
    trackingContent = _ref.trackingContent;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles,
    defaultTextColor = _useStyles.defaultTextColor;
  var _useContext = (0, _react.useContext)(_utils.AnalyticsSourceContext),
    source = _useContext.source;
  var _useGikiAnalytics = (0, _utils.useGikiAnalytics)(),
    saveGikiAnalyticsEvent = _useGikiAnalytics.saveGikiAnalyticsEvent,
    GikiAnalyticsEventType = _useGikiAnalytics.GikiAnalyticsEventType;
  var _hasOnPress = !!onPress && !!slug;
  var _hasHref = !!href && !_hasOnPress;
  var _hasIcon = !!Icon;
  var _hasTextColor = !!textColor && textColor !== '';
  var _hasBackgroundColor = !!backgroundColor && backgroundColor !== '';
  var _onPress = function _onPress() {
    onPress == null ? void 0 : onPress(slug);
  };
  var _trackingOnPress = function _trackingOnPress() {
    if (!trackingContent || !slug) return;
    saveGikiAnalyticsEvent({
      event: "".concat(GikiAnalyticsEventType.stepCategory, ".").concat(slug),
      source: source,
      content: trackingContent
    });
  };
  if (!label) return null;
  return (0, _jsxRuntime.jsx)(_Button.Button, {
    isFake: !_hasOnPress && !_hasHref,
    type: _Button.ButtonType.blank,
    textStyle: [styles.container, containerStyle, _hasBackgroundColor && {
      backgroundColor: backgroundColor
    }, (_hasOnPress || _hasHref) && styles.link, loading && styles.container_loading],
    onPress: _hasOnPress ? _onPress : undefined,
    label: ariaLabel,
    href: _hasHref ? href : undefined,
    testID: "CategoryPill",
    trackingOnPress: _trackingOnPress,
    children: !loading && (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: styles.content,
      children: [_hasIcon && (0, _jsxRuntime.jsx)(Icon, {
        color: _hasTextColor ? textColor : defaultTextColor,
        style: styles.icon
      }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
        textBreakStrategy: "simple",
        style: [styles.text, _hasTextColor && {
          color: textColor
        }],
        children: label
      })]
    })
  });
});